import * as sentry from '@sentry/browser';
import apolloClient from 'services/apollo-client';
import { surfaceNodesQuery } from 'graphql/surface-node/queries/surface-nodes';
import { set } from 'lodash/fp';

import { SurfaceNodeUnion } from 'graphql/types';
import { Description } from 'components/text-input/style';

export function useAddNodeToSurfaceInCache() {
  return addNodeToSurfaceInCache;
}

export function addNodeToSurfaceInCache(
  node: SurfaceNodeUnion,
  cache = apolloClient,
) {
  node = set('updatedAt', new Date().toISOString(), node);

  if (!node.originalNode) {
    node = set('originalNode', null, node);
  }

  try {
    const surface = node?.surface?.id;

    if (surface) {
      const variables = {
        input: { filter: { surface } },
      };

      const query = surfaceNodesQuery;

      console.log(' SURFACE NODES ', query);

      console.log(' SURFACE NODES2 ', variables);

      const { surfaceNodes } = cache.readQuery<any>({ query, variables });

      const newSurfaceNodes = [
        ...surfaceNodes.nodes,
        { description: null, ...node },
      ];

      console.log(' SURFACE NODES ', surfaceNodes);

      console.log(' SURFACE NODES2 ', newSurfaceNodes);
      const data = {
        surfaceNodes: set('nodes', newSurfaceNodes, surfaceNodes),
      };

      console.log(' SURFACE NODES2 ', newSurfaceNodes);

      cache.writeQuery({ query, data, broadcast: true, variables });
    }
  } catch (error) {
    console.log(
      '-------------- ERROR SAVE NODE IN CACHE FOR ' +
        node?.name +
        ' --------------',
    );
    console.error(error);
    sentry.captureException(error);
  }
}

export default useAddNodeToSurfaceInCache;
